import { registerBlockType } from '@wordpress/blocks';
import { useBlockProps, RichText, InnerBlocks } from '@wordpress/block-editor';
import Edit from './edit';
import save from './save';
import metadata from './block.json';
// import Icon from '../Icon';

registerBlockType( metadata.name, {
	edit: Edit,
	save,
} );
